import ImageOne from '../image/ImageOne.jpg';
import ImageTwo from '../image/ImageTwo.jpg';
import ImageThree from '../image/ImageThree.jpg';
import ImageFour from '../image/ImageFour.jpg';
import ImageFive from '../image/ImageFive.jpg';
import OneImage from '../image/OneImage.jpg';
import TwoImage from '../image/TwoImage.jpg';
import ThreeImage from '../image/ThreeImage.jpg';
import FourImage from '../image/FourImage.jpg';
import FiveImage from '../image/FiveImage.jpg';

export const SliderData = [
    {
        title: 'Odessey 1 in Aquarius Void',
        price: '$ 4,000,000',
        path: '/contact',
        label: 'Know More',
        image: ImageOne,
        alt: 'Project'
    },
    {
        title: 'Lunar Scout',
        price: '$ 1,000,000,000',
        path: '/contact',
        label: 'Know More',
        image: ImageTwo,
        alt: 'Project'
    },
    {
        title: "Martian Expedition, Expected' 2028",
        price: '$ 45,000,000,00,000',
        path: '/contact',
        label: 'Know More',
        image: ImageThree,
        alt: 'Project'
    },
    {
        title: 'Tera Rover at TrES-2b',
        price: '$ 5,500,000',
        path: '/contact',
        label: 'Know More',
        image: ImageFour,
        alt: 'Project'
    },
    {
        title: 'Genesis Station, Genesis Prime',
        price: '$ 9,000,000,000',
        path: '/contact',
        label: 'Know More',
        image: ImageFive,
        alt: 'Project'
    }
];


export const SliderDataTwo = [
    {
        title: 'Resource Mining',
        price: 'Actively engaged in the extraction of resources from celestial bodies such as asteroids and planets. These resources can include precious metals, water, and other valuable materials that can support the growth of space settlements and advance space exploration.',
        path: '/contact',
        image: OneImage,
        alt: 'Project'
    },
    {
        title: 'Emerging Technologies',
        price: 'Use of advanced robotics, artificial intelligence, and machine learning for remote exploration, resource extraction, and satellite operation. We are also exploring the use of new propulsion systems, such as nuclear-powered engines, to make space travel faster, more efficient, and more reliable. ',
        path: '/contact',
        image: TwoImage,
        alt: 'Project'
    },
    {
        title: 'Space colonization and exploration',
        price: 'Dedicated to the establishment of human settlements in space, and the exploration of our solar system and beyond. They are working towards developing the necessary technology, infrastructure, and resources to make long-term habitation in space a reality.',
        path: '/contact',
        image: FourImage,
        alt: 'Project'
    },
    {
        title: 'Satellites and Planetary Mapping',
        price: 'Develops and operates satellites for a variety of purposes, such as remote sensing, communication, and scientific research. Designed to provide crucial data and services, includes mapping the surface, studying the atmosphere, and analyzing the composition and potential for resources.',
        path: '/contact',
        image: ThreeImage,
        alt: 'Project'
    },
    {
        title: 'Commercial Space Travel',
        price: 'Launches commercial rockets for various purposes, including satellite deployment, crewed missions, and payload delivery in a Reasonable Paycheck. Our aim is to make space access more affordable and reliable, enabling more frequent and cost-effective missions to be conducted.',
        path: '/contact',
        image: FiveImage,
        alt: 'Project'
    }
];

